import { render, staticRenderFns } from "./BCXConfirm.vue?vue&type=template&id=3dcb0ec5&scoped=true"
import script from "./BCXConfirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXConfirm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXConfirm.vue?vue&type=style&index=0&id=3dcb0ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb0ec5",
  null
  
)

export default component.exports